<template>
    <div>
        <p v-if="label" class="caption grey--text text--darken-1 mb-1">{{ label }}</p>

        <v-sheet class="transparent variant-image-selector">
            <div row wrap class="scrollable-area-wrapper" ref="content-area">
                <div :style="scrollableAreaStyle">
                    <div
                        v-for="item in items"
                        :key="`${item.value}-variant-image-selector-item`"
                        class="d-inline-block"
                    >
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-img
                                    v-if="item.image"
                                    class="variant-image-selector-item"
                                    :class="{ bordered: item.value == value }"
                                    :src="item.image"
                                    @click="$emit('input', item.value)"
                                    :width="itemWidth"
                                    aspect-ratio="0.75"
                                    :alt="item.value"
                                    v-on="on"
                                />
                                <v-responsive
                                    v-else
                                    class="variant-image-selector-item"
                                    :class="{ bordered: item.value == value }"
                                    :style="getStyle(item)"
                                    @click="$emit('input', item.value)"
                                    :width="itemWidth"
                                    aspect-ratio="0.75"
                                    :alt="item.value"
                                    v-on="on"
                                />
                            </template>
                            <span>{{ item.value }}</span>
                        </v-tooltip>
                    </div>
                </div>
            </div>
            <v-btn
                v-if="isNavigationVisible && prevBtnVisible"
                flat
                absolute
                class="navigation-button left pa-0"
                @click="changeOffset(false)"
            >
                <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
                v-if="isNavigationVisible && nextBtnVisible"
                flat
                absolute
                class="navigation-button right pa-0"
                @click="changeOffset()"
            >
                <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
        </v-sheet>
    </div>
</template>

<style scoped lang="scss">
.variant-image-selector {
    .scrollable-area-wrapper {
        overflow: hidden;
        white-space: nowrap;

        .variant-image-selector-item {
            margin-right: 4px;
            &.bordered {
                outline: 1px solid #000;
                outline-offset: -1px;
            }
        }
    }
    .navigation-button {
        top: calc(50% - 15px);
        &.v-btn {
            width: 25px;
            min-width: 25px;
            height: 25px;
        }
        background-color: rgba(255, 255, 255, 0.75);
        z-index: 99999;
        &.left {
            left: 10px;
        }
        &.right {
            right: 10px;
        }
    }
}
</style>

<script>
export default {
    props: {
        label: String,
        value: null,
        items: {
            type: Array,
            default: () => [],
        },
        visibleItemsLimit: {
            type: Number,
            default: 6,
        },
    },
    mounted() {
        this.width = this.$parent.$el.clientWidth;
        if (window) {
            window.addEventListener('resize', this.onResize);
            if ('ontouchstart' in window && this.items.lentgh > this.visibleItemsLimit) {
                const ref = this.$refs['content-area'];
                ref.addEventListener('touchstart', this.onTouchStart);
                ref.addEventListener('touchmove', this.onTouchMove);
                ref.addEventListener('touchend', this.onTouchEnd);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
        if ('ontouchstart' in window && this.items.lentgh > this.visibleItemsLimit) {
            const ref = this.$refs['content-area'];
            ref.removeEventListener('touchstart', this.onTouchStart);
            ref.removeEventListener('touchmove', this.onTouchMove);
            ref.removeEventListener('touchend', this.onTouchEnd);
        }
    },
    data() {
        return {
            width: 0,
            offset: 0,
            initPosition: null,
            lastPosition: 0,
        };
    },
    computed: {
        itemWidth() {
            return this.width / this.visibleItemsLimit - 4;
        },
        isNavigationVisible() {
            return this.visibleItemsLimit < this.items.length;
        },
        scrollableAreaStyle() {
            return {
                marginLeft: `${this.offset}px`,
            };
        },
        fullWidth() {
            return (this.itemWidth + 5) * this.items.length;
        },
        areaPosition() {
            return Math.abs(this.offset) + (this.itemWidth + 5) * this.visibleItemsLimit;
        },
        prevBtnVisible() {
            return this.offset < 0;
        },
        nextBtnVisible() {
            return this.areaPosition < this.fullWidth;
        },
    },
    methods: {
        onResize() {
            this.width = this.$parent.$el.clientWidth;
        },
        changeOffset(next = true) {
            const offset = this.itemWidth + 5;
            this.offset = next ? this.offset - offset : this.offset + offset;
        },
        onTouchStart(e) {
            this.initPosition = e.touches[0].clientX;
        },
        onTouchMove(e) {
            if (!this.initPosition) {
                return;
            }
            const currentPosition = e.touches[0].clientX;
            const diff = this.initPosition - currentPosition;
            if (this.lastPosition == 0) {
                this.offset = -diff;
            } else {
                this.offset = this.lastPosition + -diff;
            }
        },
        onTouchEnd() {
            this.initPosition = null;

            if (!this.prevBtnVisible) {
                this.offset = 0;
            } else if (!this.nextBtnVisible) {
                this.offset = -((this.items.length - this.visibleItemsLimit) * (this.itemWidth + 5));
            }
            this.lastPosition = this.offset;
        },
        getStyle(item) {
            const style = {};
            const value = item.text ? item.text : '';
            if (value.length > 0) {
                if (value.indexOf('#') === 0) {
                    style['background-color'] = value;
                } else {
                    style['background-image'] = `url(${value})`;
                }
            }
            return style;
        },
    },
};
</script>
